var moment = require('moment');

var dateFormat = 'MM/DD/YYYY HH:mm';

function formatCertifiedInstrumentDate(value) {
  var date;

  if (value === null || typeof value === 'undefined') {
    return 'Pending';
  }

  if (typeof value === 'string') {
    value = value.trim();
    if (!value || value.toLowerCase() === 'pending') {
      return 'Pending';
    }
    date = /^-?\d+(\.\d+)?$/.test(value)
      ? moment(Number(value))
      : moment(value, moment.ISO_8601, true);
  } else {
    date = moment(value);
  }

  return date.isValid() ? date.format(dateFormat) : 'Pending';
}

function buildCertifiedInstrumentDateSummary(record) {
  record = record || {};
  return {
    calibratedOn: formatCertifiedInstrumentDate(record.calibratedOn),
    calibrationDue: formatCertifiedInstrumentDate(record.calibrationDue)
  };
}

module.exports = {
  buildCertifiedInstrumentDateSummary,
  formatCertifiedInstrumentDate
};
